<div class="folder-info-container">
  <mat-card>
    <mat-card-title>{{
      (sectionText$ | async)['UnresolvedMessages']
    }}</mat-card-title>
    <mat-card-content>
      <portal-folder-info
        *ngFor="let label of (messagingSummary$ | async).results"
        [messageTypeId]="label.MessageTypeId"
        [name]="label.MessageType"
        [text]="(sectionText$ | async)['Unresolved'](label.MessageType)"
        [count]="label.Unresolved"
        (goto)="goToMessagesByLabel($event)"
        (goToMessages)="goToMessagesByType($event)"
      >
      </portal-folder-info>
    </mat-card-content>
  </mat-card>
</div>
